var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mgl-map-wrapper" },
    [_vm._m(0), _vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { ref: "container", attrs: { id: _vm.mapId } })
  }
]
render._withStripped = true

export { render, staticRenderFns }